<template>
  <div id="home">
    <el-container style="min-height: 1080px">
      <el-header style="padding: 0;">
        <qx-top></qx-top>
      </el-header>
      <el-container>
      <el-aside width="250px">
        <side>
        </side>
      </el-aside>
      <el-main>
        <el-alert v-if="showAlert"
          style="margin-bottom: 20px;"
          title="您的账户已被封禁(Your account has been banned)"
          type="error">
       </el-alert>
        <router-view class="body"></router-view>
      </el-main>
      </el-container>
    </el-container>
  </div>
</template>
<script>
  import QxTop from './QxTop.vue'
  import Side from './Side.vue'

  export default {
    components: {
      QxTop, Side
    },
    computed: {
      showAlert: function() {
        return this.$store.state.accountInfo.status === '封禁'
      }
    }
    
  }
</script>
<style scoped>
#home >>> section {
  height: 100%;
}

</style>

